import { useEffect, useState } from "react";
import axios from "axios";
import { PRODUCTS } from "@/data/products";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Toggle to sync the real print-shop-125 product listings.
// Kept OFF for now so the curated sample prints (with images) are shown.
// Flip to `true` (once listings include images) to make the landing page and
// print-shop-125 "one and the same".
const USE_LIVE_FEED = false;

// Loads the product catalog. When USE_LIVE_FEED is off we simply serve the
// built-in sample catalog. When on, it pulls the live feed from the backend
// (which proxies print-shop-125) and falls back to local on any error.
export const useCatalog = () => {
  const [products, setProducts] = useState(PRODUCTS);
  const [connected, setConnected] = useState(false);
  const [source, setSource] = useState("local");
  const [loading, setLoading] = useState(USE_LIVE_FEED);

  useEffect(() => {
    if (!USE_LIVE_FEED) return;
    let active = true;
    axios
      .get(`${API}/products`)
      .then((res) => {
        if (!active) return;
        const items = res.data?.products;
        // Only swap in feed items that actually have images, so the UI never
        // shows broken/empty tiles.
        const withImages = Array.isArray(items)
          ? items.filter((p) => p.image)
          : [];
        if (withImages.length) {
          setProducts(withImages);
          setConnected(Boolean(res.data?.connected));
          setSource(res.data?.source || "local");
        }
      })
      .catch(() => {
        /* keep local fallback */
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { products, connected, source, loading };
};
